export default __webpack_public_path__ + "static/media/italy2.912f4004.webp";